import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

var FormMethod;
(function (FormMethod) {
    FormMethod["dialog"] = "dialog";
    FormMethod["get"] = "get";
    FormMethod["post"] = "post";
})(FormMethod || (FormMethod = {}));
const DEFAULT_DENSE = false;
const DEFAULT_NOVALIDATE = false;
const FORM_PROTECTED_ATTR_MAP = new Map([
    ['action', 'pvd-action'],
    ['id', 'pvd-id'],
    ['method', 'pvd-method'],
    ['novalidate', 'pvd-novalidate'],
]);
/**
 * Providence Form component.
 * @see {@link https://providence.fmr.com/4.x/components/form/form.html|Form documentation}
 */
class PvdForm extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        // determines if form should use regular or dense vertical spacing
        this.pvdDense = DEFAULT_DENSE;
        this.pvdNovalidate = DEFAULT_NOVALIDATE;
        // #endregion
    }
    // #endregion
    // #region public methods
    /**
     * Sets attributes on the form element that are coming from pvdNativeFormAttributes
     * @param prevAttr optional, if user updates pvdNativeFormAttributes, this will remove/update existing attributes
     */
    setNativeFormAttributes(prevAttr) {
        const targetElement = this.querySelector('form');
        this.setNativeAttributes(this.pvdNativeFormAttributes, FORM_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    }
    // #endregion
    // #region LitElement lifecycles
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.pvdNativeFormAttributes) {
            const prevAttr = changedProperties.get('pvdNativeFormAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeFormAttributes(prevAttr);
        }
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-form-root`,
            modifierPrefix: 'pvd-form',
            modifiers: [
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}"><form ?novalidate="${this.pvdNovalidate}" action="${l(this.pvdAction)}" class="pvd-form__form" id="${l(this.pvdId)}" method="${l(this.pvdMethod)}"><s-slot></s-slot></form></div>`;
    }
}
//#region Component configuration
PvdForm.componentName = 'form';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-action' }),
    __metadata("design:type", String)
], PvdForm.prototype, "pvdAction", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-dense',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'),
    }),
    __metadata("design:type", Boolean)
], PvdForm.prototype, "pvdDense", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-id' }),
    __metadata("design:type", String)
], PvdForm.prototype, "pvdId", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-method',
        ...PvdSlotifyBaseComponent.hasChanged(FormMethod),
    }),
    __metadata("design:type", String)
], PvdForm.prototype, "pvdMethod", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-novalidate',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-novalidate'),
    }),
    __metadata("design:type", Boolean)
], PvdForm.prototype, "pvdNovalidate", void 0);
__decorate([
    n({ type: Object, attribute: 'pvd-native-form-attributes' }),
    __metadata("design:type", Object)
], PvdForm.prototype, "pvdNativeFormAttributes", void 0);

export { DEFAULT_DENSE, DEFAULT_NOVALIDATE, FORM_PROTECTED_ATTR_MAP, FormMethod, PvdForm };
//# sourceMappingURL=pvd-form.js.map
